/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/prop-types */
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Triangle } from "react-loader-spinner";
import { jwtDecode } from "jwt-decode";
import toast from "react-hot-toast";
import secureLocalStorage from "react-secure-storage";
import { pickUpSharedLogin } from "../utils/sharedLogin";
export default function ProtectedRoute({ children }) {
  const initialUser = JSON.parse(secureLocalStorage.getItem("profile"));
  const [user, setUser] = useState(initialUser);
  const navigate = useNavigate();
  useEffect(() => {
    setUser(initialUser);
  }, []);
  // Logins through the shared cookie keep no token here
  const decodedToken = user?.token ? jwtDecode(user.token) : "";

  const exp = decodedToken.exp;

  useEffect(() => {
    const expirationDate = new Date(exp * 1000);
    const currentDate = new Date();

    // Check if the expiration date is in the past
    if (currentDate > expirationDate) {
      navigate("/reconciliation/login");
      toast.error("Your session has expired, please log in again");
    }
  }, [exp, navigate]);
  useEffect(() => {
    if (!user) {
      // Signed in to another app already? Pick that login up instead.
      pickUpSharedLogin().then((picked) => {
        if (!picked) navigate("/reconciliation/login");
      });
    } else if (user.results.reconciliation === "Restricted") {
      navigate("/reconciliation/login");
    }
  }, [user, navigate]);
  // Only wait while a login from another app is being checked
  if (!user) {
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Triangle
          visible={true}
          height="80"
          width="80"
          color="#4fa94d"
          ariaLabel="triangle-loading"
          wrapperStyle={{}}
          wrapperClass=""
        />
      </div>
    );
  }
  if (user) return children;
}
